/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import BufferHandler from "App/render/webgl/utils/buffer_handler";
import Batch from "App/render/webgl/renderables/batches/batch";
import MemoryManagement from "App/memory_management";

export default
class ElementArrayBufferHandler extends BufferHandler {

    public static helperArrayBufferSize: number = 524288; // 0.5MB cache buffer
    public static helperArrayBuffer: ArrayBuffer = new ArrayBuffer(ElementArrayBufferHandler.helperArrayBufferSize);

    private elementByteSize: number = 0;

    constructor(aBatch: Batch) {
        super(aBatch);
    }


    public release() {
        super.release();
    }

    public reCreateBuffer(aIndicesCount: number, aElementByteSize: number) {
        this.release();
        this.createBuffer(aIndicesCount, aElementByteSize);
    }

    public createBuffer(aIndicesCount: number, aElementByteSize: number) {
        let gl = this._context.getWebGLRenderingContext();
        this.elementByteSize = aElementByteSize;

        this.size = aIndicesCount;
        this.bytesSize = this.size * this.elementByteSize;
        this.filledSize = 0;

        this.id = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.id);
        if (aIndicesCount * this.elementByteSize < ElementArrayBufferHandler.helperArrayBufferSize) {
            gl.bufferData(
                gl.ELEMENT_ARRAY_BUFFER,
                (this.elementByteSize === 4)
                    ? new Uint32Array(ElementArrayBufferHandler.helperArrayBuffer, 0, aIndicesCount)
                    : new Uint16Array(ElementArrayBufferHandler.helperArrayBuffer, 0, aIndicesCount),
                gl.DYNAMIC_DRAW);
        } else {
            gl.bufferData(
                gl.ELEMENT_ARRAY_BUFFER,
                (this.elementByteSize === 4)
                    ? new Uint32Array(aIndicesCount)
                    : new Uint16Array(aIndicesCount),
                gl.DYNAMIC_DRAW);
        }

        MemoryManagement.addBufferObject(this.bytesSize);
    }

    public bindBuffer() {
        let gl = this._context.getWebGLRenderingContext();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.id);
    }

    public unbindBuffer() {
        let gl = this._context.getWebGLRenderingContext();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }

    public setAndGetNextFreePosition(aLength) {
        let length = this.filledSize;
        this.filledSize += aLength;
        return length;
    }

    public update(aData, aPosition) {
        let gl = this._context.getWebGLRenderingContext();
        gl.bufferSubData(gl.ELEMENT_ARRAY_BUFFER, aPosition * this.elementByteSize, aData);
    }
}
